function padTo2Digits(num: number) {
  return num.toString().padStart(2, "0");
}

export function formatDate(dateString: string): string {
  if (!dateString) return "-";

  var date = new Date(dateString);

  return [
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1),
    date.getFullYear(),
  ].join("/");
}

export function formatDateTime(dateString: string): string {
  if (!dateString) return "-";

  var date = new Date(dateString);

  const datePart = [
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1),
    date.getFullYear(),
  ].join("/");

  const timePart = [
    padTo2Digits(date.getHours()),
    padTo2Digits(date.getMinutes()),
  ].join(":");

  return `${datePart} ${timePart}`;
}

export function formatDateForFiltering(dateString: string): string {
  if (!dateString) return "";

  var date = new Date(dateString);

  return [
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1),
    date.getFullYear(),
  ].join("-");
}
